export default __webpack_public_path__ + "static/media/settings_plate.6749197c.svg";